// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"5f20ef39","198":"e871d030","226":"c30b0a0e","357":"86716d2b","606":"e871d030","652":"e871d030"}[chunkId] + ".chunk.css";
};